import { cn } from "@/lib/utils";

interface TrendData {
  day: string;
  value: number; // 0 to 10
}

interface WeeklyTrendsChartProps {
  data: TrendData[];
  title: string;
  colorClass: string;
}

export const WeeklyTrendsChart = ({ data, title, colorClass }: WeeklyTrendsChartProps) => {
  return (
    <div className="bg-card border rounded-3xl p-5 shadow-soft">
      <h3 className="text-sm font-medium mb-4">{title}</h3>
      
      <div className="h-24 flex items-end justify-between gap-2">
        {data.map((d, i) => (
          <div key={i} className="flex flex-col items-center gap-2 flex-1">
            <div className="w-full bg-secondary rounded-t-sm flex items-end justify-center h-full relative group">
              {/* Tooltip on hover */}
              <div className="absolute -top-7 opacity-0 group-hover:opacity-100 transition-opacity bg-foreground text-background text-[10px] px-2 py-1 rounded">
                {d.value}
              </div>
              <div 
                className={cn("w-full rounded-t-sm transition-all duration-500", colorClass)}
                style={{ height: `${(d.value / 10) * 100}%` }}
              />
            </div>
            <span className="text-[10px] text-muted-foreground uppercase">{d.day}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
